import * as React from 'react';
import translate from '../../locale/translate';

import Widget from '../../store/models/Widget';

interface IProps {
    widget: Widget,
    selected: boolean,
    buttons: React.ReactNode[],
}

export default class WidgetEditWrapper extends React.Component<IProps, void> {
    static propTypes = {
        widget: React.PropTypes.object.isRequired,
        selected: React.PropTypes.bool,
        buttons: React.PropTypes.array.isRequired,
    };

    render() {
        const { widget, selected, buttons } = this.props;

        const styles = [
            'panel',
            'panel-default',
            'widgetEditWrapper'
        ];

        const style = {
            borderLeftColor: widget.color
        };

        if (selected) {
            styles.push('selected');
            style["borderLeftWidth"] = "40px";
        }

        return (
            <div className={styles.join(' ')}>
                <div className="panel-heading clearfix" style={style}>
                    <h5 className="panel-title m-t-xs pull-left">
                        {widget.displayName}
                    </h5>

                    <div className="pull-right">
                        {buttons}
                    </div>
                </div>
                <div className="panel-body">
                    {this.props.children}
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/widgetCanvas/WidgetEditWrapper.tsx